import { apiBase } from 'api/api';
import { DROPDOWN_OPTIONS_ENDPOINTS } from 'api/backoffice/dropdownOptions/dropdownOptions.endpoints';
import type {
    DeliveryMethodDropdownResponse,
    ParkingStatusDropdownRequest,
    ParkingStatusDropdownResponse,
} from 'api/backoffice/dropdownOptions/dropdownOptions.types';

export const getParkingStatusDropdown = async (
    req?: ParkingStatusDropdownRequest
): Promise<{
    error: string | null;
    statusCode: number;
    payload?: ParkingStatusDropdownResponse;
}> => {
    const res = await apiBase.get<ParkingStatusDropdownResponse>(
        DROPDOWN_OPTIONS_ENDPOINTS.parkingStatuses,
        {
            params: req,
            paramsSerializer: (params) => {
                return new URLSearchParams(params).toString();
            },
        }
    );

    if (res.status >= 400) {
        return {
            error: 'Failed to fetch parking statuses',
            statusCode: res.status,
        };
    }

    return {
        error: null,
        statusCode: res.status,
        payload: res.data,
    };
};

export const getDeliveryMethodDropdown = async (): Promise<{
    error: string | null;
    statusCode: number;
    payload?: DeliveryMethodDropdownResponse;
}> => {
    const res = await apiBase.get<DeliveryMethodDropdownResponse>(
        DROPDOWN_OPTIONS_ENDPOINTS.deliveryMethods
    );

    if (res.status >= 400) {
        return {
            error: 'Failed to fetch delivery methods',
            statusCode: res.status,
        };
    }

    return {
        error: null,
        statusCode: res.status,
        payload: res.data,
    };
};
